module.exports = "<div class=\"cgp-overlay-content cgp-theme-property-background-color-base05 cgp-themes-lb-stroke cy-overlay-content\"></div>\n\n\n";